module.exports = __webpack_public_path__ + "assets/ic-twitch.994ae9cc.svg";